import { NgModule } from '@angular/core';
import { PrivacyPolicyAndCookieRoutingModule } from './privacy-policy-and-cookie-routing.module';
import { PrivacyPolicyAndCookieComponent } from './privacy-policy-and-cookie/privacy-policy-and-cookie.component';
import { StaticContentComponent } from '@components/static-content/static-content.component';
import { LegalNavbarComponent } from '@project/components/legal-navbar/legal-navbar.component';
import { TemplateModule } from '@project/shared/template/template.module';

@NgModule({
  declarations: [PrivacyPolicyAndCookieComponent],
  imports: [
    PrivacyPolicyAndCookieRoutingModule,
    StaticContentComponent,
    TemplateModule,
    LegalNavbarComponent
  ]
})
export class PrivacyPolicyAndCookieModule { }
